module.exports = __webpack_public_path__ + "static/media/front.93184886.png";